import validate from "/workspace/source/artist-center.idus.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/workspace/source/artist-center.idus.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "blocked-authenticated": () => import("/workspace/source/artist-center.idus.com/middleware/blocked-authenticated.ts"),
  "blocked-unauthenticated": () => import("/workspace/source/artist-center.idus.com/middleware/blocked-unauthenticated.ts")
}